import Vue from 'vue';

import * as VeeValidate from 'vee-validate';
import {
  ValidationProvider, ValidationObserver, extend, configure,
} from 'vee-validate';
import {
  required, min, max, regex, email, confirmed,
} from 'vee-validate/dist/rules';
import ValidateForm from '@/components/common/ValidateForm';

import { serviceWrapper, serviceConfigs } from '@/services/configs';

import errorMessages from '@/static/localizations/validation-messages';

import {
  removeHTMLTags,
} from '@/static/helpers/';

Vue.component('ValidationProvider', ValidationProvider);
Vue.component('ValidationObserver', ValidationObserver);
Vue.component('ValidateForm', ValidateForm);

// var modes = {
// aggressive: aggressive,
// eager: eager,
// lazy: lazy
// };
configure({
  mode: 'eager',
});

// const onlyEnglishPages = [
//   '/login',
//   '/register',
//   '/forgot-password',
//   '/reset-password',
// ];

const currentLocale = 'en';
// if (onlyEnglishPages.includes(window.location.pathname)) {
//   currentLocale = 'en';
// } else {
//   currentLocale = window.localStorage.getItem('locale') === 'tr-TR' ? 'tr' : 'en';
// }

Vue.use(VeeValidate, {
  inject: false,
  locale: currentLocale,
});

extend('required', {
  ...required,
  message: errorMessages.lang[currentLocale].required,
});

extend('min', {
  ...min,
  message: errorMessages.lang[currentLocale].min,
});

extend('max', {
  ...max,
  message: errorMessages.lang[currentLocale].max,
});

extend('email', {
  ...email,
  message: errorMessages.lang[currentLocale].email,
});

extend('regex', {
  ...regex,
  message: errorMessages.lang[currentLocale].regex,
});

extend('confirmed', {
  ...confirmed,
  message: errorMessages.lang[currentLocale].confirmPassword,
});

// -------------------------------- Custom Validation

extend('checkJobCode', {
  async validate(value, { isCheckValid, afterSaveCheckDraft, jobId }) {
    if (jobId === 'undefined') jobId = 0;
    if (value.length <= 10 && value.length >= 5 && isCheckValid === 'false' && afterSaveCheckDraft !== 'false') {
      const { data: { result } } = await serviceWrapper(
        serviceConfigs.job,
        serviceConfigs.job.isExistJobCode,
        { jobCode: value, jobId },
      );
      return !result;
    }
    return true;
  },
  params: ['isCheckValid', 'afterSaveCheckDraft', 'jobId'],
  message: errorMessages.lang[currentLocale].jobCode,
});

extend('jobCode', {
  validate(value) {
    return !/[!$%^&*()_+|~=`{}[:;<>?,.@#\]\s]/g.test(value);
  },
  message: errorMessages.lang[currentLocale].validChar,
});

extend('bluCollarPosition', {
  validate(value, { isCheckBlueCollar }) {
    const isTrueSet = (isCheckBlueCollar === 'true');
    return isTrueSet ? !value.isBlueCollar : true;
  },
  params: ['isCheckBlueCollar'],
  message: errorMessages.lang[currentLocale].bluCollarPosition,
});

extend('companyTypeWelcomeIntern', {
  validate(value, { isCheckIntern }) {
    const isTrueSet = (isCheckIntern === 'true');
    return isTrueSet ? !value.isIntern : true;
  },
  params: ['isCheckIntern'],
  message: errorMessages.lang[currentLocale].companyTypeWelcomeIntern,
});

extend('eachCharacterLimit', {
  validate(value, { valueLimit }) {
    return !value.some((item) => item.displayName.length > +valueLimit);
  },
  params: ['valueLimit'],
  message: errorMessages.lang[currentLocale].eachCharacterLimit,
});

extend('totalCharacterLimit', {
  validate(value, { totalValueLimit }) {
    let totalCharacter = 0;
    value.forEach((item) => {
      totalCharacter += item.displayName.length;
    });
    return !(totalCharacter > +totalValueLimit);
  },
  params: ['totalValueLimit'],
  message: errorMessages.lang[currentLocale].totalCharacterLimit,
});

extend('url', {
  validate(value) {
    // eslint-disable-next-line no-useless-escape
    return /^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,8}(:[0-9]{1,5})?(\/.*)?$/i.test(value.trim());
  },
  message: errorMessages.url,
});

extend('noUrl', {
  validate(value) {
    // only coens.io url allowed
    const result = /(http(s)?:\/\/)?\b(www\.)?coens\.io(\/|\?.*)?/.test(value.trim());
    if (result) return true;
    return !/(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9]\.[^\s]{2,}|[a-zA-Z0-9]*\.[a-zA-Z0-9]*\/[a-zA-Z0-9])/i.test(value.trim());
  },
  message: errorMessages.lang[currentLocale].noUrl,
});

extend('onlyEnglishLetters', {
  validate(value) {
    const result = /[ığüşöçİĞÜŞÖÇ]/.test(value.split('@')[0].trim());
    if (result) return false;
    return true;
  },
  message: errorMessages.lang[currentLocale].email,
});

extend('noEmail', {
  validate(value) {
    // eslint-disable-next-line no-control-regex
    return !/(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/.test(value.trim());
  },
  message: errorMessages.lang[currentLocale].noEmail,
});

extend('max_option', {
  validate(value, maxValue) {
    return value.length <= maxValue[0];
  },
  message: errorMessages.lang[currentLocale].max_option,
});

extend('min_option', {
  validate(value, minValue) {
    return value.length >= minValue[0];
  },
  message: errorMessages.lang[currentLocale].min_option,
});

extend('onlyStringAndNumber', {
  validate(value) {
    if (/^[0-9a-zA-ZğüşöçİĞÜŞÖÇ]+$/.test(value)) {
      return /[a-zA-ZğüşöçİĞÜŞÖÇ]/.test(value);
    } return false;
  },
  message: errorMessages.lang[currentLocale].onlyStringAndNumber,
});

extend('validChar', {
  validate(value) {
    if (/^[a-zA-ZğüşöçıİĞÜŞÖÇ\s]*$/.test(value)) {
      return /^[a-zA-ZğüşöçıİĞÜŞÖÇ\s]*$/.test(value);
    } return false;
  },
  message: errorMessages.lang[currentLocale].validChar,
});

extend('min_plain_text', {
  validate(value, ref) {
    const length = ref[0];

    if (value === undefined || value === null) {
      return false;
    }
    return removeHTMLTags(value).length >= length;
  },
  message: errorMessages.lang[currentLocale].min_plain_text,
});

extend('max_plain_text', {
  validate(value, ref) {
    const length = ref[0];

    if (value === undefined || value === null) {
      return false;
    }
    return removeHTMLTags(value).length <= length;
  },
  message: errorMessages.lang[currentLocale].max_plain_text,
});

extend('notSame', {
  validate(value, ref) {
    const notSame = ref[0];

    if (value === undefined || value === null) {
      return false;
    }
    return removeHTMLTags(value) !== notSame;
  },
  message: errorMessages.lang[currentLocale].wrongCode,
});

extend('showCompanyName', {
  validate(value) {
    if (value === undefined || value === null) return false;
    return value.id === '-1';
  },
  message: errorMessages.lang[currentLocale].showCompanyName,
});
extend('checked', {
  validate(value, { otherValue = 'false' }) {
    return otherValue === 'true' || value;
  },
  params: ['otherValue'],
  message: errorMessages.lang[currentLocale].required,
});
extend('apperanceSelect', {
  validate(value, { otherValue = 'false' }) {
    return otherValue === 'true' || value;
  },
  params: ['otherValue'],
  message: errorMessages.lang[currentLocale].apperanceSelect,
});

extend('emailRegex', {
  validate(value) {
    // eslint-disable-next-line no-control-regex
    return /^(?:[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?)$/.test(value.trim());
  },
  message: errorMessages.lang[currentLocale].noEmail,
});
